"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ConfigProvider_1 = require("../ConfigProvider");
// TODO as 的目标需要处理 href 的情况，探索下能否去掉 as，改成有 href 再 as，比如 linkAs
function Item(_a) {
    var className = _a.className, as = _a.as, href = _a.href, props = tslib_1.__rest(_a, ["className", "as", "href"]);
    var prefix = ConfigProvider_1.usePrefix('breadcrumb-item');
    className = classnames_1.default(prefix, className);
    if (as) {
        return react_1.createElement(as, tslib_1.__assign({ className: className,
            href: href }, props));
    }
    if (href == null) {
        return react_1.default.createElement("span", tslib_1.__assign({ className: className }, props));
    }
    return react_1.default.createElement("a", tslib_1.__assign({ className: className, href: href }, props));
}
exports.default = Item;
//# sourceMappingURL=Item.js.map